
        // Import from firebase-config.js (which uses NPM)
        import { auth, db } from './firebase-config.js';
        import {
            signInWithEmailAndPassword,
            onAuthStateChanged
        } from 'firebase/auth';

        console.log('🔐 Login page loaded');
        console.log('🔥 Auth object:', auth ? '✅ Auth ready' : '❌ Auth failed');
        console.log('🗄️ DB object:', db ? '✅ DB ready' : '❌ DB failed');

        // DOM Elements
        const loginForm = document.getElementById('loginForm');
        const emailInput = document.getElementById('email');
        const passwordInput = document.getElementById('password');
        const loginBtn = document.getElementById('loginBtn');
        const loginText = document.getElementById('loginText');
        const errorMessage = document.getElementById('errorMessage');
        const errorText = document.getElementById('errorText');
        const rememberMe = document.getElementById('rememberMe');

        // ========================================
        // CHECK IF ALREADY LOGGED IN
        // ========================================

        onAuthStateChanged(auth, (user) => {
            if (user) {
                // Already logged in - redirect to dashboard
                window.location.href = 'admin.html';
            }
        });

        // ========================================
        // LOAD SAVED CREDENTIALS
        // ========================================

        const savedEmail = localStorage.getItem('adminEmail');
        const savedPassword = localStorage.getItem('adminPassword');

        if (savedEmail && savedPassword) {
            emailInput.value = savedEmail;
            passwordInput.value = savedPassword;
            rememberMe.checked = true;
        }

        // ========================================
        // HANDLE LOGIN
        // ========================================

        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const email = emailInput.value.trim();
            const password = passwordInput.value.trim();

            // Validate
            if (!email || !password) {
                showError('Please enter both email and password');
                return;
            }

            // Show loading state
            loginBtn.disabled = true;
            loginText.innerHTML = '<span class="spinner"></span> Logging in...';
            hideError();

            try {
                // Attempt login with Firebase
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                console.log('✅ Login successful:', user.email);

                // Save credentials if "Remember me" is checked
                if (rememberMe.checked) {
                    localStorage.setItem('adminEmail', email);
                    localStorage.setItem('adminPassword', password);
                } else {
                    localStorage.removeItem('adminEmail');
                    localStorage.removeItem('adminPassword');
                }

                // Redirect to admin dashboard
                window.location.href = 'admin.html';

            } catch (error) {
                console.error('❌ Login error:', error);

                let message = 'Invalid email or password. Please try again.';

                // Handle specific Firebase auth errors
                switch (error.code) {
                    case 'auth/user-not-found':
                        message = 'No account found with this email address.';
                        break;
                    case 'auth/wrong-password':
                        message = 'Incorrect password. Please try again.';
                        break;
                    case 'auth/too-many-requests':
                        message = 'Too many failed attempts. Please try again later.';
                        break;
                    case 'auth/invalid-email':
                        message = 'Please enter a valid email address.';
                        break;
                    case 'auth/user-disabled':
                        message = 'This account has been disabled. Please contact support.';
                        break;
                    default:
                        message = 'Login failed. Please check your credentials and try again.';
                }

                showError(message);

                // Reset button
                loginBtn.disabled = false;
                loginText.textContent = 'Login to Dashboard';
            }
        });

        // ========================================
        // HELPER FUNCTIONS
        // ========================================

        function showError(message) {
            errorText.textContent = message;
            errorMessage.classList.add('show');
        }

        function hideError() {
            errorMessage.classList.remove('show');
        }

        // ========================================
        // KEYBOARD SHORTCUTS
        // ========================================

        // Press Enter to submit
        passwordInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                loginForm.dispatchEvent(new Event('submit'));
            }
        });

        // ========================================
        // LOG TO CONSOLE
        // ========================================

        console.log('🔐 IRIE GYM Admin Login ready!');
        console.log('📧 Use admin@iriegyjm.com to login');
    